import React from 'react';
import {DefaultPage} from '../../../Components/DefaultPage';
import {HeadFC} from 'gatsby';
import {SEO} from '../../../Components/SEO';
import {ArticleHeader} from '../../../Components/ArticleHeader';
import {StaticImage} from 'gatsby-plugin-image';
import {ArticleBlock} from '../../../Components/ArticleBlock';
import {MessengerName} from '../../../Components/MessengersName';
import {ReciteQuran} from '../../../Components/ReciteQuran';
import {SAWS} from '../../../Components/fonts/SAWS';
import {Blockquote} from '../../../Components/BlockQuote';
import {SWT} from '../../../Components/fonts/SWT';
import {ReadProgress} from '../../../Components/ReadProgress';
import {FinishArticle} from '../../../Components/FinishArticle';
import {SpecialWoman} from '../../../Components/SpecialWoman';
export default function MulheresIntroducao() {
  return (
    <DefaultPage>
      <ReadProgress />
      <ArticleHeader
        h1="Mulheres que fizeram história - Maria"
        h2="A Mãe de Jesus no Islam"
        headerImage={<StaticImage src="" alt="" />}
      />
      <div className="container">
        <ArticleBlock
          text={
            <>
              <p>
                <SpecialWoman name="Maryam" />, a Mãe de{' '}
                <MessengerName name="Issa" />, detém uma posição muito especial
                no Islam, e Deus a proclama como a melhor mulher entre toda a
                humanidade, a quem Ele escolhe sobre todas as outras mulheres
                devido à sua religiosidade e devoção.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      وَإِذْ قَالَتِ ٱلْمَلَـٰٓئِكَةُ يَـٰمَرْيَمُ إِنَّ ٱللَّهَ
                      ٱصْطَفَىٰكِ وَطَهَّرَكِ وَٱصْطَفَىٰكِ عَلَىٰ نِسَآءِ
                      ٱلْعَـٰلَمِينَ ٤٢
                    </p>
                    <p>
                      يَـٰمَرْيَمُ ٱقْنُتِى لِرَبِّكِ وَٱسْجُدِى وَٱرْكَعِى مَعَ
                      ٱلرَّٰكِعِينَ ٤٣
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Recorda-te de quando os anjos disseram: Ó Maria, é certo
                      que Deus te elegeu e te purificou, e te preferiu a todas
                      asmulheres da humanidade!
                    </p>
                    <p>
                      Ó Maria, consagra-te ao Senhor! Prostra-te e genuflecte,
                      com os genuflexos!
                    </p>
                  </>
                }
                quranIdex="3:42-43"
              />
              <p>
                <strong>
                  Ela também foi um exemplo de Deus, como Ele disse:
                </strong>
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      وَمَرْيَمَ ٱبْنَتَ عِمْرَٰنَ ٱلَّتِىٓ أَحْصَنَتْ فَرْجَهَا
                      فَنَفَخْنَا فِيهِ مِن رُّوحِنَا وَصَدَّقَتْ بِكَلِمَـٰتِ
                      رَبِّهَا وَكُتُبِهِۦ وَكَانَتْ مِنَ ٱلْقَـٰنِتِينَ ١٢
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E com Maria, filha de Imran, que conservou o seu pudor, e
                      a qual alentamos com o Nosso Espírito, por te acreditado
                      nas palavras do seu Senhor e nos Seus Livros, e por se Ter
                      contado entre os consagrados.
                    </p>
                  </>
                }
                quranIdex="6:12"
              />
              <p>
                De fato ela foi uma mulher adequada a trazer um milagre como o
                de <MessengerName name="Issa" />, que nasceu sem pai.
              </p>
              <p>
                Ela era conhecida por sua religiosidade e castidade, e se fosse
                diferente, ninguém teria acreditado em sua alegação de ter dado
                à luz enquanto mantinha seu estado de virgindade, uma crença e
                fato que o Islam considera verdadeiros. Sua natureza especial
                foi um dos muitos milagres provados em sua tenra infância.
                Deixe-nos contar o que Deus revelou em relação à bela história
                de <SpecialWoman name="Maryam" />.
              </p>
            </>
          }
        />
        <ArticleBlock
          text={
            <>
              <h3>
                A infância de <SpecialWoman name="Maryam" />
              </h3>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      ۞ إِنَّ ٱللَّهَ ٱصْطَفَىٰٓ ءَادَمَ وَنُوحًۭا وَءَالَ
                      إِبْرَٰهِيمَ وَءَالَ عِمْرَٰنَ عَلَى ٱلْعَـٰلَمِينَ ٣٣
                    </p>
                    <p>
                      ذُرِّيَّةًۢ بَعْضُهَا مِنۢ بَعْضٍۢ ۗ وَٱللَّهُ سَمِيعٌ
                      عَلِيمٌ
                    </p>
                    <p>
                      إِذْ قَالَتِ ٱمْرَأَتُ عِمْرَٰنَ رَبِّ إِنِّى نَذَرْتُ
                      لَكَ مَا فِى بَطْنِى مُحَرَّرًۭا فَتَقَبَّلْ مِنِّىٓ ۖ
                      إِنَّكَ أَنتَ ٱلسَّمِيعُ ٱلْعَلِيمُ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Sem dúvida que Deus preferiu Adão, Noé, a família de
                      Abraão e a de Imran, aos seus contemporâneos,
                    </p>
                    <p>
                      Famílias descendentes umas das outras, porque Deus é
                      Oniouvinte, Sapientíssimo.
                    </p>
                    <p>
                      Recorda-te de quando a mulher de Imran disse: Ó Senhor
                      meu, é certo que consagrei a ti, integralmente, o fruto do
                      meu ventre; aceita-o, porque és o Oniouvinte, o
                      Sapientíssimo.
                    </p>
                  </>
                }
                quranIdex="3:33-35"
              />
              <p>
                Maria nasceu para Heli e sua esposa Hannah, que era de
                descendência davídica, vindo, portanto, de uma família de
                profetas, de <MessengerName name="Ibrahim" /> a{' '}
                <MessengerName name="Nuh" />, a <MessengerName name="Adam" />.
              </p>
              <p>
                Como mencionado no versículo, ela nasceu para a família
                escolhida de Heli, que nasceu na família escolhida de{' '}
                <MessengerName name="Ibrahim" />, que também nasceu em uma
                família escolhida.
              </p>
              <p>
                Hannah era uma mulher estéril que desejava uma criança, e ela
                prometeu a Deus que, se Ele a concedesse um filho, ela o
                consagraria a Seu serviço no Templo. Deus respondeu à sua
                invocação, e ela concebeu uma criança.
              </p>
              <p>
                Quando ela deu à luz se entristeceu, porque sua criança era uma
                menina, e geralmente eram os meninos que prestavam serviço no
                Bait-ul-Maqdis.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      فَلَمَّا وَضَعَتْهَا قَالَتْ رَبِّ إِنِّى وَضَعْتُهَآ
                      أُنثَىٰ وَٱللَّهُ أَعْلَمُ بِمَا وَضَعَتْ وَلَيْسَ
                      ٱلذَّكَرُ كَٱلْأُنثَىٰ ۖ وَإِنِّى سَمَّيْتُهَا مَرْيَمَ
                      وَإِنِّىٓ أُعِيذُهَا بِكَ وَذُرِّيَّتَهَا مِنَ
                      ٱلشَّيْطَـٰنِ ٱلرَّجِيمِ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E quando concebeu, disse: Ó Senhor meu, concebi uma
                      menina. Mas Deus bem sabia o que eu tinha concebido, e um
                      macho não é o mesmo que uma fêmea. Eis que a chamo Maria;
                      ponho-a, bem como à sua descendência, sob a Tua proteção,
                      contra o maldito Satanás.
                    </p>
                  </>
                }
                quranIdex="3:36"
              />
              <p>
                Quando ela expressou sua tristeza, Deus a repreendeu dizendo:{' '}
                <em>...Deus bem sabia o que eu tinha concebido</em>
              </p>
              <p>
                …porque Deus escolheu sua filha, <SpecialWoman name="Maryam" />,
                para ser a mãe de um dos maiores milagres da criação: o
                nascimento virginal de Jesus, que Deus o exalte. Hannah chamou a
                sua filha de Maria (Mariam em árabe) e invocou a Deus que a
                protegesse e à sua criança de Satanás:
              </p>
              <Blockquote author="Al-Quran 3:36 (parte)">
                E eu a chamei de Maria (Mariam), e a entrego e à sua
                descendência à Tua proteção, contra o maldito Satanás.
              </Blockquote>
              <p>
                Deus de fato aceitou essa súplica, e Ele deu a{' '}
                <SpecialWoman name="Maryam" /> e seu filho que estava por vir,{' '}
                <MessengerName name="Issa" />, um tratamento especial – que não
                foi dado a ninguém antes e nem a ninguém depois; nenhum dos dois
                foi afligido pelo toque de Satanás ao nascer. O profeta Muhammad{' '}
                <SAWS />, disse:
              </p>
              <Blockquote>
                “Todos recebem um toque de Satanás ao nascer, e a criança nasce
                chorando por causa de seu toque, exceto Maria e seu filho
                (Jesus).” (compilado por Ahmed)
              </Blockquote>
              <p>
                Aqui, nós podemos ver imediatamente a similaridade entre essa
                narrativa e a teoria cristã da “Imaculada Conceição” de Maria e{' '}
                <MessengerName name="Issa" />, embora aqui exista uma grande
                diferença entre as duas.
              </p>
              <p>
                O Islam não propaga a teoria do “pecado original” e, portanto,
                não aceita essa interpretação de como eles eram livres do toque
                de Satanás, mas ao contrário essa foi uma graça dada por Deus à{' '}
                <SpecialWoman name="Maryam" /> e seu filho{' '}
                <MessengerName name="Issa" />.
              </p>
              <p>
                Como outros profetas, <MessengerName name="Issa" /> foi
                protegido de cometer pecados graves.
              </p>
              <p>
                Quanto à <SpecialWoman name="Maryam" />, mesmo se adotarmos a
                posição de que ela não era uma profetisa, ela todavia recebeu a
                proteção e orientação de Deus que Ele concede aos crentes
                piedosos.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      فَتَقَبَّلَهَا رَبُّهَا بِقَبُولٍ حَسَنٍۢ وَأَنۢبَتَهَا
                      نَبَاتًا حَسَنًۭا وَكَفَّلَهَا زَكَرِيَّا ۖ كُلَّمَا
                      دَخَلَ عَلَيْهَا زَكَرِيَّا ٱلْمِحْرَابَ وَجَدَ عِندَهَا
                      رِزْقًۭا ۖ قَالَ يَـٰمَرْيَمُ أَنَّىٰ لَكِ هَـٰذَا ۖ
                      قَالَتْ هُوَ مِنْ عِندِ ٱللَّهِ ۖ إِنَّ ٱللَّهَ يَرْزُقُ
                      مَن يَشَآءُ بِغَيْرِ حِسَابٍ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Seu Senhor a aceitou benevolentemente e a educou
                      esmeradamente, confiando-a a Zacarias. Cada vem que
                      Zacarias avisitava, no oratório, encontrava-a provida de
                      alimentos, e lhe perguntava: Ó Maria, de onde te vem isso?
                      Ela respondia: De Deus!, porque Deus agracia
                      imensuravelmente quem Lhe apraz.
                    </p>
                  </>
                }
                quranIdex="3:37"
              />
              <p>
                No nascimento de <SpecialWoman name="Maryam" />, sua mãe Hannah
                a levou a Bait-ul-Maqdis e a ofereceu àqueles no templo para
                crescer sob sua tutela.
              </p>
              <p>
                Conhecendo a nobreza e religiosidade de sua família, eles
                discutiram sobre quem teria a honra de educá-la.
              </p>
              <p>
                Eles concordaram em tirar a sorte, e não foi ninguém menos que o
                profeta <MessengerName name="Zakariya" /> o escolhido. Foi sob o
                seu cuidado e tutela que ela foi educada.
              </p>
            </>
          }
        />
        <ArticleBlock
          text={
            <>
              <h3>Milagres em sua presença e visitação dos anjos</h3>
              <p>
                Enquanto <SpecialWoman name="Maryam" /> crescia, até mesmo o
                profeta <MessengerName name="Zakariya" /> notou as suas
                características especiais, devido aos vários milagres que
                ocorreram na presença dela.
              </p>
              <p>
                <SpecialWoman name="Maryam" />, durante o seu crescimento,
                recebeu um quarto recluso dentro do templo onde ela deveria se
                devotar à adoração de Deus.
              </p>
              <p>
                Toda vez que <MessengerName name="Zakariya" /> entrava na câmara
                para ver o que ela precisava, ele encontrava frutas abundantes e
                fora da estação na presença dela.
              </p>
              <Blockquote author="Al-Quran 3:37 (parte)">
                Cada vez que Zacarias entrava na câmara, ele a encontrava
                provida com sustento.Ele disse, ‘Ó Maria! De onde te provém
                isso?’. Ela respondia ‘De Deus’. Certamente Deus concede
                sustento sem medida a quem Ele quer.
              </Blockquote>
              <p>
                Ela foi visitada pelos anjos em mais de uma ocasião. Deus nos
                diz que os anjos a visitaram e a informaram de sua condição
                louvável entre a humanidade.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      وَإِذْ قَالَتِ ٱلْمَلَـٰٓئِكَةُ يَـٰمَرْيَمُ إِنَّ ٱللَّهَ
                      ٱصْطَفَىٰكِ وَطَهَّرَكِ وَٱصْطَفَىٰكِ عَلَىٰ نِسَآءِ
                      ٱلْعَـٰلَمِينَ ٤٢
                    </p>
                    <p>
                      يَـٰمَرْيَمُ ٱقْنُتِى لِرَبِّكِ وَٱسْجُدِى وَٱرْكَعِى مَعَ
                      ٱلرَّٰكِعِينَ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Recorda-te de quando os anjos disseram: Ó Maria, é certo
                      que Deus te elegeu e te purificou, e te preferiu a todas
                      asmulheres da humanidade!
                    </p>
                    <p>
                      Ó Maria, consagra-te ao Senhor! Prostra-te e genuflecte,
                      com os genuflexos!
                    </p>
                  </>
                }
                quranIdex="3:42-43"
              />
              <p>
                Devido a essas visitações dos anjos e por ela ter sido escolhida
                sobre as outras mulheres, alguns consideram que{' '}
                <SpecialWoman name="Maryam" /> foi uma profetisa.
              </p>
              <p>
                Mas mesmo que não tenha sido, o que é matéria de debate, o Islam
                a considera detentora da posição mais alta entre todas as
                mulheres da criação devido à sua piedade e devoção, e devido ao
                fato dela ter sido escolhida para o nascimento milagroso de{' '}
                <MessengerName name="Issa" />.
              </p>
            </>
          }
        />
        <ArticleBlock
          text={
            <>
              <h3>Sua anunciação</h3>
              <p>
                Deus nos informa de quando os anjos deram à Maria (RAA) as boas
                novas de uma criança, a posição de seu filho na terra e alguns
                dos milagres que ele realizaria:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      إِذْ قَالَتِ ٱلْمَلَـٰٓئِكَةُ يَـٰمَرْيَمُ إِنَّ ٱللَّهَ
                      يُبَشِّرُكِ بِكَلِمَةٍۢ مِّنْهُ ٱسْمُهُ ٱلْمَسِيحُ عِيسَى
                      ٱبْنُ مَرْيَمَ وَجِيهًۭا فِى ٱلدُّنْيَا وَٱلْـَٔاخِرَةِ
                      وَمِنَ ٱلْمُقَرَّبِينَ ٤٥
                    </p>
                    <p>
                      وَيُكَلِّمُ ٱلنَّاسَ فِى ٱلْمَهْدِ وَكَهْلًۭا وَمِنَ
                      ٱلصَّـٰلِحِينَ ٤٦
                    </p>
                    <p>
                      قَالَتْ رَبِّ أَنَّىٰ يَكُونُ لِى وَلَدٌۭ وَلَمْ
                      يَمْسَسْنِى بَشَرٌۭ ۖ قَالَ كَذَٰلِكِ ٱللَّهُ يَخْلُقُ مَا
                      يَشَآءُ ۚ إِذَا قَضَىٰٓ أَمْرًۭا فَإِنَّمَا يَقُولُ لَهُۥ
                      كُن فَيَكُونُ ٤٧
                    </p>
                    <p>
                      وَيُعَلِّمُهُ ٱلْكِتَـٰبَ وَٱلْحِكْمَةَ وَٱلتَّوْرَىٰةَ
                      وَٱلْإِنجِيلَ ٤٨
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E quando os anjos disseram: Ó Maria, por certo que Deus te
                      anuncia o Seu Verbo, cujo nome será o Messias, Jesus,
                      filho de Maria, nobre neste mundo e no outro, e que se
                      contará entre os diletos de Deus.
                    </p>
                    <p>
                      Falará aos homens, ainda no berço, bem como na maturidade,
                      e se contará entre os virtuosos.
                    </p>
                    <p>
                      Perguntou: Ó Senhor meu, como poderei ter um filho, se
                      mortal algum jamais me tocou? Disse-lhe o anjo: Assim
                      será. Deus cria o que deseja, posto que quando decreta
                      algo, diz: Seja! e é.
                    </p>
                    <p>
                      Ele lhe ensinará o Livro, a sabedoria, a Tora e o
                      Evangelho.
                    </p>
                  </>
                }
                quranIdex="3:45-48"
              />
              <p>Isso se parece muito com as palavras mencionadas na Bíblia:</p>
              <Blockquote author="Lucas 1:26-38">
                <p>
                  Não tenhas medo, Maria, porque fostes favorecida por Deus.
                  Muito em breve ficarás grávida e terás um menino, a quem
                  chamarás Jesus.
                </p>
                <p>Atônita, ela respondeu:</p>
                <p>Mas como posso ter um filho, se sou virgem?</p>
              </Blockquote>
              <p>
                Essa situação foi um grande teste para ela, porque sua enorme
                piedade e devoção eram conhecidas por todos. Ela previu que as
                pessoas a acusariam de não ser casta.
              </p>
              <p>
                Em outras ayát (versículos) do{' '}
                <a href="https://quran.com/pt">Alcorão</a>, Allah <SWT /> relata
                mais detalhes da anunciação por <MessengerName name="Jibril" />{' '}
                de que ela daria à luz a um profeta.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      فَٱتَّخَذَتْ مِن دُونِهِمْ حِجَابًۭا فَأَرْسَلْنَآ
                      إِلَيْهَا رُوحَنَا فَتَمَثَّلَ لَهَا بَشَرًۭا سَوِيًّۭا ١٧
                    </p>
                    <p>
                      قَالَتْ إِنِّىٓ أَعُوذُ بِٱلرَّحْمَـٰنِ مِنكَ إِن كُنتَ
                      تَقِيًّۭا ١٨
                    </p>
                    <p>
                      قَالَ إِنَّمَآ أَنَا۠ رَسُولُ رَبِّكِ لِأَهَبَ لَكِ
                      غُلَـٰمًۭا زَكِيًّۭا ١٩
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E colocou uma cortina para ocultar-se dela (da família), e
                      lhe enviamos o Nosso Espírito, que lhe
                      apareceupersonificado, como um homem perfeito.
                    </p>
                    <p>
                      Disse-lhe ela: Guardo-me de ti no Clemente, se é que temes
                      a Deus.
                    </p>
                    <p>
                      Explicou-lhe: Sou tão-somente o mensageiro do teu Senhor,
                      para agraciar-te com um filho imaculado.
                    </p>
                  </>
                }
                quranIdex="19:17-19"
              />
              <p>
                Uma vez, quando <SpecialWoman name="Maryam" /> foi ao templo
                para os seus afazeres, o anjo
                <MessengerName name="Jibril" /> apareceu para ela na forma de um
                homem.
              </p>
              <p>
                Ela ficou assustada devido à proximidade do homem, e buscou
                refúgio em Deus.
              </p>
              <p>
                <MessengerName name="Jibril" /> então disse a ela que ele não
                era um homem comum, mas um anjo enviado por Deus para anunciar a
                ela que ela teria uma criança muito pura. Atônita, ela exclamou:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      قَالَتْ أَنَّىٰ يَكُونُ لِى غُلَـٰمٌۭ وَلَمْ يَمْسَسْنِى
                      بَشَرٌۭ وَلَمْ أَكُ بَغِيًّۭا
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Disse-lhe: Como poderei ter um filho, se nenhum homem me
                      tocou e jamais deixei de ser casta?
                    </p>
                  </>
                }
                quranIdex="19:20"
              />
              <p>
                O anjo explicou que era um Decreto Divino que já tinha sido
                decretado, e que de fato era algo fácil para Deus, o
                Todo-Poderoso. Deus disse que o nascimento de{' '}
                <MessengerName name="Issa" />, seria um sinal de Sua
                Onipotência, e que, assim como Ele criou{' '}
                <MessengerName name="Adam" /> sem pai ou mãe, Ele criou{' '}
                <MessengerName name="Issa" />
                sem pai.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      قَالَ كَذَٰلِكِ قَالَ رَبُّكِ هُوَ عَلَىَّ هَيِّنٌۭ ۖ
                      وَلِنَجْعَلَهُۥٓ ءَايَةًۭ لِّلنَّاسِ وَرَحْمَةًۭ مِّنَّا ۚ
                      وَكَانَ أَمْرًۭا مَّقْضِيًّۭا
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Disse-lhe: Assim será, porque teu Senhor disse: Isso Me é
                      fácil! E faremos disso um sinal para os homens, e será
                      umaprova de Nossa misericórdia. E foi uma ordem
                      inexorável.
                    </p>
                  </>
                }
                quranIdex="19:21"
              />
              <p>
                Deus soprou em <SpecialWoman name="Maryam" /> o espírito de{' '}
                <MessengerName name="Issa" /> através do anjo
                <MessengerName name="Jibril" />, e <MessengerName name="Issa" />{' '}
                foi concebido em seu ventre, como Deus disse em um outro
                capítulo:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      وَمَرْيَمَ ٱبْنَتَ عِمْرَٰنَ ٱلَّتِىٓ أَحْصَنَتْ فَرْجَهَا
                      فَنَفَخْنَا فِيهِ مِن رُّوحِنَا وَصَدَّقَتْ بِكَلِمَـٰتِ
                      رَبِّهَا وَكُتُبِهِۦ وَكَانَتْ مِنَ ٱلْقَـٰنِتِينَ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E com Maria, filha de Imran, que conservou o seu pudor, e
                      a qual alentamos com o Nosso Espírito, por te acreditado
                      nas palavras do seu Senhor e nos Seus Livros, e por se Ter
                      contado entre os consagrados.
                    </p>
                  </>
                }
                quranIdex="66:12"
              />
              <p>
                Quando os sinais de gravidez se tornaram aparentes,{' '}
                <SpecialWoman name="Maryam" /> ficou ainda mais preocupada com o
                que as pessoas falariam sobre ela.
              </p>
              <p>
                As notícias sobre ela se espalharam, e como era inevitável,
                alguns começaram a acusá-la de não ser casta.
              </p>
              <p>
                Ao contrário da crença cristã de que{' '}
                <SpecialWoman name="Maryam" /> era casada com José, o Islam
                mantém a posição de que ela não era noiva ou casada, e foi isso
                que causou a ela tal angústia.
              </p>
              <p>
                Ela sabia que as pessoas chegariam à única conclusão lógica em
                relação à sua gravidez: de que tinha acontecido fora do
                casamento.
              </p>
              <p>
                <SpecialWoman name="Maryam" /> se isolou das pessoas e partiu
                para uma outra terra. Deus diz:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      ۞ فَحَمَلَتْهُ فَٱنتَبَذَتْ بِهِۦ مَكَانًۭا قَصِيًّۭا ٢٢
                    </p>
                    <p>
                      فَأَجَآءَهَا ٱلْمَخَاضُ إِلَىٰ جِذْعِ ٱلنَّخْلَةِ قَالَتْ
                      يَـٰلَيْتَنِى مِتُّ قَبْلَ هَـٰذَا وَكُنتُ نَسْيًۭا
                      مَّنسِيًّۭا ٢٣
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      E quando concebeu, retirou-se, com um rebento a um lugar
                      afastado.
                    </p>
                    <p>
                      As dores do parto a constrangeram a refugiar-se junto a
                      uma tamareira. Disse: Oxalá eu tivesse morrido antes
                      disto, ficando completamente esquecida.
                    </p>
                  </>
                }
                quranIdex="19:22-23"
              />
            </>
          }
        />
        <ArticleBlock
          text={
            <>
              <h3>
                O nascimento de <MessengerName name="Issa" />
              </h3>
              <p>
                No início de seu parto ela estava em profunda dor, tanto mental
                quanto física.
              </p>
              <p>
                Como poderia uma mulher de tal piedade e nobreza ter um filho
                fora do casamento? Nós devemos mencionar aqui que{' '}
                <SpecialWoman name="Maryam" /> teve uma gravidez normal, que não
                foi diferente em nada a das outras mulheres, e teve o seu filho
                como as outras também.
              </p>
              <p>
                Na crença cristã, <SpecialWoman name="Maryam" /> não sofreu as
                dores do parto, porque o Cristianismo e o Judaísmo consideram a
                menstruação e o parto como uma maldição sobre as mulheres pelo
                pecado de Eva.
              </p>
              <p>
                O Islam não compartilha dessa crença, nem da teoria do “Pecado
                Original”, pelo contrário, enfatiza fortemente que ninguém
                carrega o pecado de outros.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      قُلْ أَغَيْرَ ٱللَّهِ أَبْغِى رَبًّۭا وَهُوَ رَبُّ كُلِّ
                      شَىْءٍۢ ۚ وَلَا تَكْسِبُ كُلُّ نَفْسٍ إِلَّا عَلَيْهَا ۚ
                      وَلَا تَزِرُ وَازِرَةٌۭ وِزْرَ أُخْرَىٰ ۚ ثُمَّ إِلَىٰ
                      رَبِّكُم مَّرْجِعُكُمْ فَيُنَبِّئُكُم بِمَا كُنتُمْ فِيهِ
                      تَخْتَلِفُونَ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Dize ainda: Como poderia eu adorar outro senhor que não
                      fosse Deus, uma vez que Ele é o Senhor de todas as coisas?
                      Nenhuma alma receberá outra recompensa que não for a
                      merecida, e nenhuma pecador arcará cm culpas alheias,
                      Então, retornareis ao vosso Senhor, o Qual vos inteirará
                      de vossas divergências.
                    </p>
                  </>
                }
                quranIdex="6:164"
              />
              <p>
                Não apenas isso, mas nem o Alcorão nem o profeta Muhammad{' '}
                <SAWS />, sequer mencionam que foi Eva quem comeu da árvore e
                instigou Adão.
              </p>
              <p>Ao contrário, o Alcorão culpa ou apenas Adão ou a ambos.</p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      فَوَسْوَسَ لَهُمَا ٱلشَّيْطَـٰنُ لِيُبْدِىَ لَهُمَا مَا
                      وُۥرِىَ عَنْهُمَا مِن سَوْءَٰتِهِمَا وَقَالَ مَا
                      نَهَىٰكُمَا رَبُّكُمَا عَنْ هَـٰذِهِ ٱلشَّجَرَةِ إِلَّآ
                      أَن تَكُونَا مَلَكَيْنِ أَوْ تَكُونَا مِنَ ٱلْخَـٰلِدِينَ
                      ٢٠
                    </p>
                    <p>
                      وَقَاسَمَهُمَآ إِنِّى لَكُمَا لَمِنَ ٱلنَّـٰصِحِينَ ٢١
                    </p>
                    <p>
                      فَدَلَّىٰهُمَا بِغُرُورٍۢ ۚ فَلَمَّا ذَاقَا ٱلشَّجَرَةَ
                      بَدَتْ لَهُمَا سَوْءَٰتُهُمَا وَطَفِقَا يَخْصِفَانِ
                      عَلَيْهِمَا مِن وَرَقِ ٱلْجَنَّةِ ۖ وَنَادَىٰهُمَا
                      رَبُّهُمَآ أَلَمْ أَنْهَكُمَا عَن تِلْكُمَا ٱلشَّجَرَةِ
                      وَأَقُل لَّكُمَآ إِنَّ ٱلشَّيْطَـٰنَ لَكُمَا عَدُوٌّۭ
                      مُّبِينٌۭ ٢٢
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Então, Satã lhe cochichou, para revelar-lhes o que, até
                      então, lhes havia sido ocultado das suas vergonhas,
                      dizendo-lhes: Vosso Senhor vos proibiu esta árvore para
                      que não vos convertêsseis em dois anjos ou não estivésseis
                      entre os imortais.
                    </p>
                    <p>E ele lhes jurou: Sou para vós um fiel conselheiro.</p>
                    <p>
                      E, com enganos, seduziu-os. Mas quando colheram o fruto da
                      árvore, manifestaram-se-lhes as vergonhas e começaram
                      acobrir-se com folhas, das plantas do Paraíso. Então, seu
                      Senhor os admoestou: Não vos havia vedado esta árvore e
                      não voshavia dito que Satanás era vosso inimigo declarado?
                    </p>
                  </>
                }
                quranIdex="7:20-22"
              />
              <p>
                <SpecialWoman name="Maryam" />, devido à sua angústia e dor,
                desejou que nunca tivesse sido criada, e exclamou:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    فَأَجَآءَهَا ٱلْمَخَاضُ إِلَىٰ جِذْعِ ٱلنَّخْلَةِ قَالَتْ
                    يَـٰلَيْتَنِى مِتُّ قَبْلَ هَـٰذَا وَكُنتُ نَسْيًۭا
                    مَّنسِيًّۭا
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      As dores do parto a constrangeram a refugiar-se junto a
                      uma tamareira. Disse: Oxalá eu tivesse morrido antes
                      disto, ficando completamente esquecida.
                    </p>
                  </>
                }
                quranIdex="19:23"
              />
              <p>
                Após o parto, e quando sua angústia não podia ser maior, o bebê
                recém-nascido, <MessengerName name="Issa" />, milagrosamente
                falou abaixo dela, lhe tranquilizando e reassegurando que Deus a
                protegeria.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      فَنَادَىٰهَا مِن تَحْتِهَآ أَلَّا تَحْزَنِى قَدْ جَعَلَ
                      رَبُّكِ تَحْتَكِ سَرِيًّۭا ٢٤
                    </p>
                    <p>
                      وَهُزِّىٓ إِلَيْكِ بِجِذْعِ ٱلنَّخْلَةِ تُسَـٰقِطْ
                      عَلَيْكِ رُطَبًۭا جَنِيًّۭا ٢٥
                    </p>
                    <p>
                      فَكُلِى وَٱشْرَبِى وَقَرِّى عَيْنًۭا ۖ فَإِمَّا تَرَيِنَّ
                      مِنَ ٱلْبَشَرِ أَحَدًۭا فَقُولِىٓ إِنِّى نَذَرْتُ
                      لِلرَّحْمَـٰنِ صَوْمًۭا فَلَنْ أُكَلِّمَ ٱلْيَوْمَ
                      إِنسِيًّۭا ٢٦
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Porém, chamou-a uma voz, junto a ela: Não te atormentes,
                      porque teu Senhor fez correr um riacho a teus pés!
                    </p>
                    <p>
                      E sacode o tronco da tamareira, de onde cairão sobre ti
                      tâmaras madura e frescas.
                    </p>
                    <p>
                      Come, pois, bebe e consola-te; e se vires algum humano,
                      faze-o saber que fizeste um voto de jejum ao Clemente, e
                      que hoje não poderás falar com pessoa alguma.
                    </p>
                  </>
                }
                quranIdex="19:24-26"
              />
              <p>
                <SpecialWoman name="Maryam" /> se tranquilizou. Esse foi o
                primeiro milagre realizado nas mãos de{' '}
                <MessengerName name="Issa" />.
              </p>
              <p>
                Ele falou tranquilizando sua mãe em seu nascimento, e uma vez
                mais quando as pessoas a viram carregando seu bebê
                recém-nascido.
              </p>
              <p>Quando elas a viram a acusaram, dizendo:</p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      فَأَتَتْ بِهِۦ قَوْمَهَا تَحْمِلُهُۥ ۖ قَالُوا۟
                      يَـٰمَرْيَمُ لَقَدْ جِئْتِ شَيْـًۭٔا فَرِيًّۭا
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Regressou ao seu povo levando-o (o filho) nos braços. E
                      lhes disseram: Ó Maria, eis que fizeste algo
                      extraordinário!
                    </p>
                  </>
                }
                quranIdex="19:27"
              />
              <p>
                Ela simplesmente apontou para <MessengerName name="Issa" /> e
                ele milagrosamente falou, como Deus tinha prometido a ela na
                anunciação.
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      وَيُكَلِّمُ ٱلنَّاسَ فِى ٱلْمَهْدِ وَكَهْلًۭا وَمِنَ
                      ٱلصَّـٰلِحِينَ
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Falará aos homens, ainda no berço, bem como na maturidade,
                      e se contará entre os virtuosos.
                    </p>
                  </>
                }
                quranIdex="3:46"
              />
              <p>
                <MessengerName name="Issa" /> disse às pessoas:
              </p>
              <ReciteQuran
                arabicText={
                  <>
                    <p>
                      قَالَ إِنِّى عَبْدُ ٱللَّهِ ءَاتَىٰنِىَ ٱلْكِتَـٰبَ
                      وَجَعَلَنِى نَبِيًّۭا ٣٠
                    </p>
                    <p>
                      وَجَعَلَنِى مُبَارَكًا أَيْنَ مَا كُنتُ وَأَوْصَـٰنِى
                      بِٱلصَّلَوٰةِ وَٱلزَّكَوٰةِ مَا دُمْتُ حَيًّۭا ٣١
                    </p>
                    <p>
                      وَبَرًّۢا بِوَٰلِدَتِى وَلَمْ يَجْعَلْنِى جَبَّارًۭا
                      شَقِيًّۭا ٣٢
                    </p>
                    <p>
                      وَٱلسَّلَـٰمُ عَلَىَّ يَوْمَ وُلِدتُّ وَيَوْمَ أَمُوتُ
                      وَيَوْمَ أُبْعَثُ حَيًّۭا ٣٣
                    </p>
                  </>
                }
                portugueseText={
                  <>
                    <p>
                      Ele lhes disse: Sou o servo de Deus, o Qual me concedeu o
                      Livro e me designou como profeta.
                    </p>
                    <p>
                      Fez-me abençoado, onde quer que eu esteja, e me encomendou
                      a oração e (a paga do) zakat enquanto eu viver.
                    </p>
                    <p>
                      E me fez piedoso para com a minha mãe, não permitindo que
                      eu seja arrogante ou rebelde.
                    </p>
                    <p>
                      A paz está comigo, desde o dia em que nasci; estará comigo
                      no dia em que eu morrer, bem como no dia em que eu
                      forressuscitado.
                    </p>
                  </>
                }
                quranIdex="19:30-33"
              />
              <p>
                A partir daqui começa o episódio de{' '}
                <MessengerName name="Issa" />, seu esforço de uma vida para
                chamar as pessoas para adorar a Deus, escapando das conspirações
                e planos daqueles judeus que se empenhariam em matá-lo.
              </p>
            </>
          }
        />
        <ArticleBlock
          text={
            <>
              <h3>Maria no Islam</h3>
              <p>
                Nós já discutimos a grande posição que o Islam concede à{' '}
                <SpecialWoman name="Maryam" />.
              </p>
              <p>
                O Islam dá a ela a posição de ser a mais perfeita das mulheres
                criadas.
              </p>
              <p>
                No Alcorão, nenhuma mulher recebe mais atenção do que{' '}
                <SpecialWoman name="Maryam" />, embora todos os profetas, com
                exceção de <MessengerName name="Adam" />, tivessem mães.
              </p>
              <p>
                Dos 114 capítulos do Alcorão, ela está entre as oito pessoas que
                têm um capítulo com o seu nome: o capítulo dezenove, “Maryam”,
                que é “Maria” em árabe.
              </p>
              <p>
                O terceiro capítulo do Alcorão tem o nome do pai dela, Imran
                (Heli). Os capítulos Mariam e Imran estão entre os capítulos
                mais bonitos no Alcorão.
              </p>
              <p>
                Além disso, <SpecialWoman name="Maryam" /> é a única mulher
                especificamente mencionada pelo nome no Alcorão. O profeta
                Muhammad <SAWS /> disse:
              </p>
              <Blockquote author="Al-Tirmizi">
                <p>
                  As melhores mulheres do mundo são quatro: Maria, a filha de
                  Heli; Aasiyah, a esposa do Faraó; Khadija bint Khuwaylid (a
                  esposa do profeta Muhammad, que a bênção e paz de Deus estejam
                  sobre ele); e Fátima, filha de Muhammad, o Mensageiro de Deus.
                </p>
              </Blockquote>
              <p>
                Apesar de todos esses méritos que mencionamos,{' '}
                <SpecialWoman name="Maryam" /> e seu filho
                <MessengerName name="Issa" /> foram somente humanos, e não
                tinham características que fossem além do campo da humanidade.
              </p>
              <p>Ambos foram seres criados e ambos “nasceram” nesse mundo.</p>
              <p>
                Embora eles estivessem sob o cuidado especial de Deus, que os
                prevenia de cometer pecados graves (proteção total – como outros
                profetas – no caso de <MessengerName name="Issa" />, e proteção
                parcial – como outras pessoas virtuosas – no caso de{' '}
                <SpecialWoman name="Maryam" />, se adotarmos a posição de que
                ela não foi uma profetisa), eles ainda estavam sujeitos a
                cometer erros.
              </p>
              <p>
                Ao contrário do Cristianismo, que considera{' '}
                <SpecialWoman name="Maryam" /> como irrepreensível, acreditamos
                que ninguém possui essa qualidade de perfeição além de Deus.
              </p>
              <p>
                O Islam ordena a crença e implementação de monoteísmo estrito;
                de que ninguém tem quaisquer poderes sobrenaturais além de Deus,
                e que apenas Ele merece adoração e devoção.
              </p>
              <p>
                Embora milagres tenham ocorrido nas mãos dos profetas e pessoas
                virtuosas durante suas vidas, eles não tinham poder para se
                ajudar, quanto mais a outros, após sua morte.
              </p>
              <p>
                Todos os humanos são servos de Deus, e precisam de Sua ajuda e
                misericórdia.
              </p>
              <p>
                O mesmo é verdadeiro para <SpecialWoman name="Maryam" />. Embora
                muitos milagres tenham ocorrido na presença dela, tudo cessou
                após sua morte.
              </p>
              <p>
                Quaisquer alegações que as pessoas fizeram de que viram
                aparições da Virgem, ou que pessoas foram salvas do perigo após
                invocá-la, como as mencionadas em literatura apócrifa como
                “Transitus Mariae”, são meras aparições feitas por Satanás para
                desencaminhar as pessoas da adoração e devoção ao Único
                Verdadeiro Deus.
              </p>
              <p>
                Devoções como a “Ave Maria”, recitada sobre o rosário e outros
                atos de engrandecimento, como a devoção de igrejas e festas
                específicas para
                <SpecialWoman name="Maryam" />, levam as pessoas a idolatrar e
                glorificar outros além de Deus.
              </p>
              <p>
                Devido a essas razões, o Islam proibiu estritamente inovações de
                qualquer tipo, assim como a construção de locais de adoração
                sobre túmulos, tudo para preservar a essência de todas as
                religiões enviadas por Deus, a mensagem pura para adorá-Lo,
                somente, e deixar a falsa adoração de todos os outros além
                d’Ele.
              </p>
              <p>
                <SpecialWoman name="Maryam" /> foi uma serva de Deus, e ela foi
                a mais pura de todas as mulheres, especialmente escolhida para o
                nascimento milagroso de <MessengerName name="Issa" />, um dos
                maiores de todos os profetas.
              </p>
              <p>
                Ela foi conhecida por sua piedade e castidade, e continuará a
                ser mantida nessa alta consideração através dos tempos que estão
                por vir.
              </p>
              <p>
                Sua história tem sido relatada no glorioso Alcorão desde o
                advento do profeta Muhammad <SAWS />, e continuará assim,
                inalterada em sua forma pura, até o Dia do Juízo Final.
              </p>
            </>
          }
        />
      </div>
      <FinishArticle />
    </DefaultPage>
  );
}

export const Head: HeadFC = () => {
  return (
    <SEO
      title="A história de Maria | Mesquita da Luz"
      description="Você sabia que Maria (AS) é a única mulher chamada pelo nome no Alcorão, além de nomear o único capítulo com nome de mulher no Livro Sagrado? Saiba mais sobre a importância da mãe de Jesus."
      // schema={defaultSchema}
    />
  );
};
